import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export function useCoolingTechnology() {
  const [t] = useTranslation(['projects']);

  const options = useMemo(
    () => [
      { label: 'Air Cooling', value: 'air_cooling' as const },
      { label: 'Liquid Cooling', value: 'liquid_cooling' as const },
      { label: 'Other', value: 'other' as const },
    ],
    [t]
  );

  const kv = useMemo(
    () => options.reduce((map, option) => ({ ...map, [option.value]: option.label }), {}) as Record<string, string>,
    [options]
  );

  const map = useCallback((value?: string | null) => (value ? kv[value] : null), [kv]);

  return { options, kv, map };
}
